import { render, staticRenderFns } from "./main.vue?vue&type=template&id=63be028c"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63be028c')) {
      api.createRecord('63be028c', component.options)
    } else {
      api.reload('63be028c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=63be028c", function () {
      api.rerender('63be028c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/element/popover/src/main.vue"
export default component.exports